import React from "react";
import Input from "Components/UI/Input";
import { useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import dayjs from "dayjs";
import { stringToPointNumber } from "MainPages/Utils/decimal.utils";
const boolStatus = [
  { id: "1", label: "Yes", value: true },
  { id: "0", label: "No", value: false },
];

const VehicleMaintenanceModal = ({
  mode = "I",
  onSubmit,
  show = false,
  handleClose,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    setValue,
    dateFormat,
  } = useFormContext();

  const handleModalSubmit = (e) => {
    e.stopPropagation(); 
  };

  return (
    <Modal show={show} onHide={handleClose} animation={true} centered size="lg">
      <Modal.Header
        className="modal-header border-0 custom-modal-header"
        style={{ justifyContent: "space-between" }}
      >
        <div className="page-title">
          <h4>
            {mode === "I"
              ? "Add Vehicle Maintenance"
              : "Edit Vehicle Maintenance"}
          </h4>
        </div>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        {/* <form onSubmit={handleSubmit(onSubmit)} className="needs-validation"> */}
        <form
          onSubmit={(e) => {
            handleModalSubmit(e);
            handleSubmit(onSubmit)(e);
          }}
          className="needs-validation"
        >
          <div className="form-row row">
            <div className="col-md-6 mb-3">
              <Input
                name="invoiceNumber"
                label="Invoice Number"
                labelClassName="form-label"
                placeholder="Enter Invoice Number"
                type="text"
                className={`form-control ${
                  errors.invoiceNumber ? "is-invalid" : ""
                }`}
                required
                requiredMessage="Invoice Number is required"
              />
            </div>
            <div className="col-md-6 mb-3">
              <Input
                name="invoiceDate"
                label="Invoice Date"
                labelClassName="form-label"
                placeholder="Enter Invoice Date"
                type="date"
                onChange={(date) => {
                  setValue(
                    "invoiceDate",
                    date ? dayjs(date).format(dateFormat) : ""
                  );
                  trigger("invoiceDate");
                }}
                className={`form-control ${
                  errors.invoiceDate ? "is-invalid" : ""
                }`}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                required
                requiredMessage="Invoice Date is required"
                dateFormat="YYYY-MM-DD"
                defaultValue={
                  dayjs(watch("insuranceExpiryDate"), "YYYY-MM-DD") || null
                }
              />
            </div>
            <div className="col-md-6 mb-3">
              <Input
                name="dealerName"
                label="Dealer Name"
                labelClassName="form-label"
                placeholder="Enter Dealer Name"
                type="text"
                className={`form-control ${
                  errors.dealerName ? "is-invalid" : ""
                }`}
                required
                requiredMessage="Dealer Name is required"
              />
            </div>
            <div className="col-md-6 mb-3">
              <Input
                name="vehicleDescription"
                label="Vehicle Description"
                labelClassName="form-label"
                placeholder="Enter Vehicle Description"
                type="text"
                className={`form-control ${
                  errors.vehicleDescription ? "is-invalid" : ""
                }`}
                required
                requiredMessage="Vehicle Description is required"
              />
            </div>
            <div className="col-md-6 mb-3">
              <Input
                name="amountInclGST"
                label="Amount Incl GST"
                placeholder="Enter Amount Including GST"
                type="text"
                className={`form-control ${
                  errors.amountInclGST ? "is-invalid" : ""
                }`}
                required
                requiredMessage="Amount Including GST is required"
                onChange={(e) => stringToPointNumber(e.target.value)}
                labelClassName="form-label"
              />
            </div>
            <div className="col-md-6 mb-3">
              <Input
                name="partServiced"
                label="Part Serviced"
                placeholder="Enter Part Serviced"
                type="text"
                className={`form-control ${
                  errors.partServiced ? "is-invalid" : ""
                }`}
                required
                requiredMessage="Part Serviced is required"
                labelClassName="form-label"
              />
            </div>
            <div className="col-md-6 mb-3">
              <Input
                name="maintenanceNextDueDate"
                label="Maintenance Next Due Date"
                placeholder="Enter Maintenance Next Due Date"
                type="date"
                onChange={(date) => {
                  setValue(
                    "maintenanceNextDueDate",
                    date ? dayjs(date).format(dateFormat) : ""
                  );
                  trigger("maintenanceNextDueDate");
                }}
                className={`form-control ${
                  errors.maintenanceNextDueDate ? "is-invalid" : ""
                }`}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                required
                requiredMessage="Maintenance Next Due Date is required"
                dateFormat="YYYY-MM-DD"
                defaultValue={
                  dayjs(watch("insuranceExpiryDate"), "YYYY-MM-DD") || null
                }
                labelClassName="form-label"
              />
            </div>
            <div className="col-md-6 mb-3">
              <Input
                name="lmNextDueDate"
                label="LM Next Due Date"
                placeholder="Enter LM Next Due Date"
                type="date"
                onChange={(date) => {
                  setValue(
                    "lmNextDueDate",
                    date ? dayjs(date).format(dateFormat) : ""
                  );
                  trigger("lmNextDueDate");
                }}
                className={`form-control ${
                  errors.lmNextDueDate ? "is-invalid" : ""
                }`}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                required
                requiredMessage="LM Next Due Date is required"
                dateFormat="YYYY-MM-DD"
                defaultValue={
                  dayjs(watch("insuranceExpiryDate"), "YYYY-MM-DD") || null
                }
                labelClassName="form-label"
              />
            </div>
            <div className="col-md-6 mb-3">
              <Input
                name="vehicleNumber"
                label="Vehicle Number"
                placeholder="Enter Vehicle Number"
                type="text"
                className={`form-control ${
                  errors.vehicleNumber ? "is-invalid" : ""
                }`}
                required
                requiredMessage="Vehicle Number is required"
                labelClassName="form-label"
              />
            </div>
            <div className="col-md-6 mb-3">
              <div className="mb-3">
                <Input
                  name="isActive"
                  type="commonSelect"
                  placeholder="Status"
                  className={`form-control ${
                    errors.isActive ? "is-invalid" : ""
                  }`}
                  label="Status"
                  labelClassName="form-label"
                  optionData={boolStatus}
                  required={true}
                  requiredMessage="Status is required"
                  onChange={(selectedOption) => {
                    console.log(selectedOption);
                    setValue("isActive", selectedOption);
                    trigger("isActive");
                  }}
                  defaultValue={watch("isActive")}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                />
              </div>
            </div>
          </div>

          <div className="text-end mt-3">
            <button type="submit" className="btn btn-primary">
              {mode === "I" ? "Add" : "Update"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

VehicleMaintenanceModal.propTypes = {
  mode: PropTypes.oneOf(["I", "E"]),
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default VehicleMaintenanceModal;
